module.exports = __webpack_public_path__ + "static/media/coin.1a41e085.svg";